// Handle pool: Star Wars Legends / Expanded Universe pilot canon spanning
// Rogue Squadron, Wraith Squadron, X-Wing novels, OT background pilots,
// Imperial aces, Lost Stars, Aftermath, Squadrons, Battlefront II, Heir to
// the Empire, Jedi: Fallen Order, KOTOR/SWTOR, Republic Commando, Clone
// Wars, Rebels, Mandalorian, Andor, High Republic — plus Star-Wars-flavored
// synthesized names for breadth. Marquee saga family names (Skywalker,
// Solo, Kenobi, etc.) remain banned. See PRD §2 carve-out + §16.
//
// Reference: https://en.wikipedia.org/wiki/List_of_Star_Wars_characters
export const FIRST_NAMES: readonly string[] = [
  // OT Rogue / Wraith / Imperial / X-Wing series canon
  'Wedge', 'Biggs', 'Hobbie', 'Wes', 'Tycho', 'Corran', 'Gavin', 'Jek', 'Dack', 'Zev',
  'Dutch', 'Garven', 'Iolo', 'Inyri', 'Nawara', 'Ooryl', 'Pash', 'Kell', 'Myn', 'Falynn',
  'Voort', 'Garik', 'Soontir', 'Turr', 'Carnor', 'Maarek', 'Snap', 'Jess', 'Kare', 'Bodhi',
  'Tiree', 'Davish', 'Theron', 'Puck', 'Asyr', 'Erisi', 'Bror', 'Plourr', 'Tyria', 'Castin',
  'Jesmin', 'Shalla', 'Dia', 'Elassar', 'Kir', 'Jagged', 'Shara', 'Caluan', 'Norra', 'Mirax',
  'Atril', 'Ibtisam', 'Lujayne', 'Riv', 'Thane', 'Ciena', 'Jaden', 'Kyle', 'Rostek', 'Bren',
  'Larma', 'Tallie', 'Joph', 'Kaz', 'Yolo', 'Keyan', 'Olin', 'Iden', 'Lindon', 'Crix',
  'Andoorni', 'Rhysati', 'Khejeen', 'Avan', 'Standro', 'Hohass', 'Eurrsk', 'Wran', 'Wynssa', 'Hamo',
  'Tomaas', 'Yargo', 'Berisse', 'Hesse', 'Kendy', 'Nash', 'Jude', 'Greer', 'Bollie', 'Antoc',
  'Greez', 'Cere', 'Bode', 'Cal', 'Talon', 'Niles', 'Gilad', 'Shen', 'Grace', 'Syal',
  // X-Wing comics / novels supplemental + Aftermath
  'Derek', 'Elscol', 'Dllr', 'Liat', 'Halley', 'Cubber', 'Davin', 'Lorrir', 'Pesso', 'Sinjir',
  'Jas', 'Temmin', 'Mart', 'Lana', 'Koth', 'Senya', 'Satele', 'Aric', 'Tanno', 'Vector',
  // Clone Wars / Bad Batch / Rebels / Mandalorian / Andor
  'Cody', 'Rex', 'Fives', 'Hardcase', 'Tup', 'Hevy', 'Wolffe', 'Bly', 'Gree', 'Neyo',
  'Howzer', 'Hunter', 'Tech', 'Wrecker', 'Crosshair', 'Omega', 'Cid', 'Phee', 'Steela', 'Korkie',
  'Almec', 'Zeb', 'Alexsandr', 'Maketh', 'Ryder', 'Cikatro', 'Jai', 'Gregor', 'Greef', 'Cobb',
  'Migs', 'Fennec', 'Cad', 'Bossk', 'Embo', 'Aurra', 'Hondo', 'Latts', 'Paz', 'Axe',
  'Koska', 'Pershing', 'Penn', 'Bib', 'Toro', 'Ranzar', 'Mythrol', 'Kuiil', 'Bix', 'Dedra',
  'Syril', 'Vel', 'Cinta', 'Maarva', 'Luthen', 'Kleya', 'Karis', 'Morgan', 'Marrok', 'Baylan',
  // KOTOR / SWTOR / Republic Commando
  'Kal', 'Walon', 'Etain', 'Niner', 'Darman', 'Sev', 'Mical', 'Bao', 'Mira', 'Brianna',
  'Visas', 'Vrook', 'Vandar', 'Mission', 'Canderous', 'Jolee', 'Juhani', 'Nico', 'Andronikos', 'Vette',
  'Pierce', 'Ashara', 'Khem', 'Talos', 'Skadge', 'Mako', 'Akaavi', 'Risha', 'Corso', 'Guss',
  // Solo / Heir to the Empire / Legends EU misc
  'Tobias', 'Qira', 'Rio', 'Enfys', 'Dryden', 'Garm', 'Booster', 'Doman', 'Borsk', 'Sien',
  // High Republic / Naboo / Resistance / additional Jedi/Imperial
  'Cohl', 'Nym', 'Vana', 'Reti', 'Avar', 'Loden', 'Stellan', 'Bell', 'Elzar', 'Reath',
  'Vernestra', 'Keeve', 'Terec', 'Ceret', 'Trask', 'Suvam', 'Yuthura', 'Sabe', 'Sola', 'Ruwee',
  'Jobal', 'Pooja', 'Ryoo', 'Corde', 'Kaydel', 'Paige', 'Beaumont', 'Vober', 'Brom', 'Cassio',
  'Orman', 'Wynn', 'Frisk', 'Saesee', 'Even', 'Stass', 'Bultar', 'Coleman', 'Tsui', 'Joclad',
  'Wullf', 'Rae', 'Sasha', 'Lendre', 'Treen', 'Sora', 'Eli', 'Jorus', 'Ric', 'Thalias',
  // Star-Wars-flavored synthesized
  'Kael', 'Jorrin', 'Vex', 'Brann', 'Tarn', 'Ryss', 'Drev', 'Kyran', 'Lor', 'Sira',
  'Orin', 'Tev', 'Roan', 'Sorn', 'Marn', 'Vren', 'Theris', 'Yenn', 'Ravi', 'Kessa',
  'Dren', 'Talor', 'Veska', 'Brik', 'Nyssa', 'Terrin', 'Reish', 'Pavla', 'Joran', 'Larek',
];

export const SURNAMES: readonly string[] = [
  // OT Rogue / Wraith / Imperial / X-Wing series canon
  'Antilles', 'Darklighter', 'Klivian', 'Janson', 'Celchu', 'Horn', 'Porkins', 'Ralter', 'Senesca', 'Vander',
  'Krail', 'Dreis', 'Naeco', 'Arana', 'Forge', 'Cracken', 'Tainer', 'Donos', 'Sandskimmer', 'Loran',
  'Phanan', 'Targon', 'Fel', 'Phennir', 'Jax', 'Kanos', 'Stele', 'Onasi', 'Wexley', 'Pava',
  'Bey', 'Ematt', 'Seilar', 'Ven', 'Qrygg', 'Nunb', 'Dlarit', 'Jace', 'Ilo', 'Beruss',
  'Trizzin', 'Donn', 'Ekwesh', 'Nelprin', 'Passik', 'Kun', 'Lampar', 'Rook', 'Terrik', 'Tabanne',
  'Korr', 'Katarn', 'Derlin', 'Lintra', 'Threnalli', 'Ziff', 'Leech', 'Seastriker', 'Kyrell', 'Ree',
  'Farlander', 'Azzameen', 'Versio', 'Meeko', 'Hask', 'Javes', 'Venzee', 'Madine', 'Karrde', 'Pellaeon',
  'Hui', 'Ynr', 'Slee', 'Jcir', 'Narcassan', 'Suurgav', 'Imado', 'Blastwell', 'Sai', 'Cuell',
  'Idele', 'Windrider', 'Edivon', 'Prindel', 'Merrick', 'Dritus', 'Junda', 'Akuna', 'Kestis', 'Ferrier',
  'Mattis', 'Valen', 'Grey', 'Sonnel', 'Starflare', 'Vonreg', 'Highmoon', 'Koovah', 'Aerilon', 'Kerrill',
  // X-Wing comics / KOTOR / Aftermath supplemental
  'Loro', 'Nep', 'Tsayv', 'Lemm', 'Kadorto', 'Daine', 'Felth', 'Sarkin', 'Velus', 'Emari',
  'Beniko', 'Vortena', 'Tirall', 'Shan', 'Karath', 'Quinn', 'Jorgan', 'Vik', 'Hyllus', 'Marr',
  // Clone Wars / Rebels / Mandalorian / Andor
  'Skirata', 'Vau', 'Mukan', 'Calican', 'Vanth', 'Reeves', 'Woves', 'Mayfeld', 'Shand', 'Ohnaka',
  'Razzi', 'Karga', 'Vizago', 'Tua', 'Azadi', 'Kallus', 'Orrelios', 'Sing', 'Bane', 'Wesell',
  'Caleen', 'Meero', 'Karn', 'Sartha', 'Rael', 'Nemik', 'Elsbeth', 'Skoll', 'Hati', 'Genoa',
  'Vao', 'Bindo', 'Ordo', 'Drellik', 'Spar', 'Drayen', 'Riggs', 'Tuno', 'Beckett', 'Nest',
  // Imperial / Legends EU command
  'Vos', 'Iblis', 'Isard', 'Sovv', 'Feylya', 'Ventress', 'Holdo', 'Connix', 'Statura', 'Veers',
  'Piett', 'Ozzel', 'Needa', 'Jerjerrod', 'Yularen', 'Konstantine', 'Pryce', 'Sloane', 'Zsinj', 'Lapan',
  'Yendor', 'Hassin', 'Rancit', 'Rieekan', 'Dodonna', 'Strom', 'Solusar', 'Harkos', 'Vorrl', 'Rusk',
  // High Republic / Jedi / extra canon
  'Vanto', 'Tagge', 'Romodi', 'Titus', 'Cbaoth', 'Trebor', 'Choi', 'Danva', 'Tiin', 'Piell',
  'Allie', 'Swan', 'Rwoh', 'Greatstorm', 'Gios', 'Zettifar', 'Mann', 'Silas', 'Trennis', 'Kriss',
  'Naberrie', 'Ulgo', 'Tico', 'Olie', 'Cassel', 'Drallig', 'Nett', 'Marek', 'Eclipse', 'Kota',
  'Bonteri', 'Saxon', 'Krell', 'Nord', 'Bandon', 'Rau', 'Hett', 'Panaka', 'Doza', 'Yeager',
  'Aphra', 'Tolvan', 'Sturn', 'Tolwyn', 'Paratus', 'DAcy', 'Marki', 'Bulq', 'Gallandro', 'Hennix',
  // Star-Wars-flavored synthesized
  'Vexar', 'Drell', 'Kasden', 'Hovrik', 'Sandeer', 'Vrann', 'Korbis', 'Tessek', 'Raghul', 'Dremmel',
  'Vondak', 'Talmar', 'Karras', 'Vesko', 'Drevan', 'Torrin', 'Massik', 'Phelan', 'Yssan', 'Drovin',
  'Skarn', 'Vrekka', 'Caldoran', 'Marrek', 'Voskan', 'Branmir', 'Kyrsten', 'Sorell', 'Vannik', 'Korbal',
  'Drennak', 'Vhostek', 'Karran', 'Pellor', 'Vassik', 'Kortha', 'Drennel', 'Vrenn', 'Kasdar', 'Hovrek',
  'Marran', 'Veldar', 'Drassik', 'Korbil', 'Vannel', 'Tornak', 'Drovak', 'Yasdar', 'Vrennan', 'Karrak',
  'Pellan', 'Vothan', 'Sorran', 'Tarrik', 'Drevek', 'Kassar', 'Senva', 'Tessar', 'Branvek', 'Mossan',
];

const BANNED_TOKENS = [
  // PRD §2 originals
  'tatooine', 'podracer', 'anakin', 'sebulba',
  // marquee saga family names
  'skywalker', 'solo', 'kenobi', 'vader', 'organa', 'palpatine', 'sidious',
  'yoda', 'dooku', 'maul', 'tarkin',
  // sequel-era marquee
  'kylo', 'dameron', 'ahsoka',
  // factions / iconic objects
  'jedi', 'sith', 'wookiee', 'deathstar', 'empire', 'rebellion',
  'r2', 'c3po', 'bb8',
];

export function isHandleAllowed(handle: string): boolean {
  const lower = handle.toLowerCase().replace(/[^a-z0-9]/g, '');
  for (const t of BANNED_TOKENS) {
    if (lower.includes(t)) return false;
  }
  if (/^pod\d/i.test(handle) || /^pod-/i.test(handle)) return false;
  return true;
}

export function generateHandle(): string {
  // Re-roll guard: with ~300² combos and ~26 ban tokens, a handful of pairings
  // create banned substrings across the boundary (e.g. "Erisi-Threnalli" →
  // "sith", "Maarva-Derlin" → "vader", "Pesso-Loran" → "solo"). Re-roll
  // rather than hand back a handle the save path will reject.
  for (let i = 0; i < 50; i++) {
    const first = FIRST_NAMES[Math.floor(Math.random() * FIRST_NAMES.length)];
    const last = SURNAMES[Math.floor(Math.random() * SURNAMES.length)];
    const handle = `${first}-${last}`;
    if (isHandleAllowed(handle)) return handle;
  }
  return `${FIRST_NAMES[0]}-${SURNAMES[0]}`;
}

// Storage keeps the hyphen for URL/slug safety; UI shows a space. Legacy
// adjective+number handles like "DuneSkimmer-0847" don't match and fall
// through unchanged.
const NEW_FORMAT_RE = /^([A-Za-z]+)-([A-Za-z]+)$/;
export function formatHandle(handle: string): string {
  const m = NEW_FORMAT_RE.exec(handle);
  return m ? `${m[1]} ${m[2]}` : handle;
}
